import { useAppRouter } from '@/common/route/useAppRouter';
import { useCrudActions } from '@/common/view/useCrudActions';
import { activityService } from '@/services/activity';
import { reactive } from 'vue';
import { useRoute } from 'vue-router';

export function useActivityDetail() {
    const router = useAppRouter();
    const route = useRoute();

    const model = reactive({
        id: route.params.id,
        accountId: null,
        action: null,
        createTime: null,
        data: null,
        feature: null,
        firstname: null,
        lastname: null
    });

    const fetch = useCrudActions().executeAction({
        request: () => activityService.app.get(model.id),
        onSuccess: ({ data }) => Object.assign(model, data),
        onError: () => router.go(-1)
    });

    return { model, fetch };
}
